import { Outlet } from 'react-router-dom';

import { lazyWithRetry } from '@/shared/lib/lazyWithRetry';

import { ROUTES } from '@/shared/constants';

import { DirectorAccessRedirect } from '@/features/auth';
import {
  ActorCastingAccessRedirect,
  ActorProjectAccessRedirect
} from '@/features/casting';

import { LoggedOutUserComposition } from '../di/compositions/LoggedOutUser';
import { sentryCreateBrowserRouter } from '../sentry';

const ActorRegistrationPage = lazyWithRetry(
  () => import('@/pages/actor/registration')
);
const DirectorRegistrationPage = lazyWithRetry(
  () => import('@/pages/director/registration')
);
const NotFoundPage = lazyWithRetry(() => import('@/pages/not-found'));
const SignInPage = lazyWithRetry(() => import('@/pages/sign-in'));
const PasswordRecoveryPage = lazyWithRetry(
  () => import('@/pages/password-recovery')
);
const WelcomePage = lazyWithRetry(() => import('@/pages/welcome'));
const EmailVerificationPage = lazyWithRetry(
  () => import('@/pages/email-verification')
);
const PublicVideoPage = lazyWithRetry(() => import('@/pages/public-video'));

export const authRouter = sentryCreateBrowserRouter([
  {
    element: (
      <LoggedOutUserComposition>
        <Outlet />
      </LoggedOutUserComposition>
    ),
    children: [
      {
        path: ROUTES.root,
        element: <WelcomePage />
      },
      {
        path: ROUTES.public_video,
        element: <PublicVideoPage />
      },
      {
        path: ROUTES.auth.sign_in,
        element: <SignInPage />
      },
      {
        path: ROUTES.auth.director_registration,
        element: <DirectorRegistrationPage />
      },
      {
        path: ROUTES.auth.actor_registration,
        element: <ActorRegistrationPage />
      },
      {
        path: ROUTES.auth.password_recovery,
        element: <PasswordRecoveryPage />
      },
      {
        path: 'events/projects/:projectId/castings/:castingId',
        element: <ActorCastingAccessRedirect />
      },
      {
        path: 'events/projects/:projectId',
        element: <ActorProjectAccessRedirect />
      },
      {
        path: 'actors/:id',
        element: <DirectorAccessRedirect />
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  },
  {
    path: ROUTES.change_email,
    element: <EmailVerificationPage />
  }
]);
